import React, { Component, Fragment } from 'react'
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { PATHS, MARKUP } from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import { Link } from 'react-router-dom';
import MarkupBundleList from './MarkupBundleList';
import { Button, Icon, Menu, Dropdown } from 'antd';
import { omit, toArray } from 'lodash';

let permisionActions = [];

class MarkupBundle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.markupBundleState.pageSize,
                pageIndex: this.props.markupBundleState.pageIndex,
            }
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.MARKUP_BUNDLE);
        this.props.getListMarkupBundles(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, markupBundles, loadingGroup } = this.props.markupBundleState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'markupBundles'}
                        titleHeader={t('navigation.markupBundles')}
                        componentRight={
                            <Fragment>
                                {
                                    permisionActions && permisionActions.allowCreate &&
                                    <Dropdown overlay={this.createMenu} className={`cursorPointer align-items-center`}
                                        style={{ verticalAlign: 'middle', marginBottom: '0' }}>
                                        <Button className="btn btn-primary ml-3">
                                            + {t(`action.create`)}
                                        </Button>
                                    </Dropdown>
                                    // <Button className="btn btn-primary ml-3">
                                    //     <Link to={PATHS.MARKUP_BUNDLE.CREATE.path} >+ Tạo mới</Link>
                                    // </Button>
                                }
                            </Fragment>
                        }
                    />
                    <MarkupBundleList loading={isFetching}
                                  loadingGroup={loadingGroup}
                                  permisions={permisionActions}
                                  markupBundles={markupBundles}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDelete}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    createMenu = () => (
        <Menu>
            {toArray(MARKUP.CREATE_TYPE).map((type, index) => (
                <Menu.Item disabled={type.disabled} key={ index }>
                    <Link to={!type.disabled && Func.getPathWithParams(PATHS.MARKUP_BUNDLE.CREATE.path, { type: type.id })}>
                        {this.props.t(`item.markupBundle.${type.key}`)}
                    </Link>
                </Menu.Item>
            ))}
        </Menu>
    );

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListMarkupBundles(newFilters);
    }

    onDelete = (item) => {
        this.props.deleteMarkupBundleDetail(item, {
            filters: {
                pageSize: this.props.markupBundleState.pageSize,
                pageIndex: this.props.markupBundleState.pageIndex
            }
        });
    }

}

export default MarkupBundle
